export const ITEM_TYPES = [
  { value: 'ENGINEERING', label: 'Engineering', type: 'hours' },
  { value: 'LABOR', label: 'Labor', type: 'hours' },
  { value: 'MATERIALS', label: 'Materials', type: 'quantity' },
  { value: 'EQUIPMENT_AND_TOOLS', label: 'Equipment & Tools', type: 'quantity' },
  { value: 'SUBCONTRACTORS', label: 'Subcontractors', type: 'quantity' },
  { value: 'OTHER', label: 'Other', type: 'quantity' },
  { value: 'CONTINGENCY', label: 'Contingency', type: 'quantity' },
  { value: 'GENERAL_CONDITIONS', label: 'General Conditions', type: 'hours' }
]
